import React, { useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || "Something went wrong.");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#FAFAF8] flex flex-col items-center justify-center px-4"
      style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}>
      <h1 className="text-5xl tracking-[0.25em] uppercase font-light text-[#1A1A1A] mb-8">Arvay</h1>
      <div className="w-full max-w-sm bg-white border border-[#E8E8E4] shadow-sm p-8">
        {sent ? (
          <div className="text-center">
            <h2 className="text-xl font-light tracking-wider mb-4">Check your inbox</h2>
            <p className="font-sans text-xs text-neutral-500 mb-6">
              If that email is registered, a reset link is on its way from support@arvay.live
            </p>
            <a href="/" className="font-sans text-[10px] uppercase tracking-[0.18em] font-semibold underline">
              Back to Sign In
            </a>
          </div>
        ) : (
          <>
            <h2 className="text-xl font-light tracking-wider mb-1">Reset Password</h2>
            <p className="font-sans text-xs text-neutral-400 mb-6">Enter your email and we'll send a reset link.</p>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="font-sans text-[10px] uppercase tracking-[0.18em] text-neutral-500 font-semibold block mb-1.5">Email</label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} required
                  placeholder="your@email.com" data-testid="forgot-email-input"
                  className="w-full border border-[#E0E0E0] bg-[#FAFAF8] px-3 py-2.5 font-sans text-sm focus:outline-none focus:border-black transition-colors placeholder:text-neutral-300"/>
              </div>
              {error && <p className="font-sans text-xs text-red-600">{error}</p>}
              <button type="submit" disabled={loading} data-testid="forgot-submit-btn"
                className="w-full bg-black text-white font-sans text-[10px] uppercase tracking-[0.2em] font-semibold py-3.5 hover:bg-neutral-800 transition-colors disabled:opacity-50">
                {loading ? "Sending…" : "Send Reset Link"}
              </button>
            </form>
            <p className="text-center mt-4">
              <a href="/" className="font-sans text-[10px] uppercase tracking-[0.18em] text-neutral-400 hover:text-black font-semibold">
                Back to Sign In
              </a>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
